import { cn } from '@/shared/lib'

interface SpinnerProps {
  label?: string
  className?: string
}

// Пульс-точка в фирменном easing (см. .dot-pulse в токен-слое).
export function Spinner({ label = 'Загрузка', className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex items-center gap-2', className)}
    >
      <span className="dot-pulse h-2.5 w-2.5 rounded-pill bg-accent" />
    </span>
  )
}
